<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="titleDefinitions"
      :options.sync="pagination"
      :server-items-length="totalTitleDefinitions"
      :loading="loading"
      :footer-props="{
        'showFirstLastPage':true,
        'items-per-page-options': [10, 20, 50, 100]
      }"
      class="elevation-1"
    >
      <template v-slot:item.image="{ item }">
        <v-img
          max-height="150"
          max-width="150"
          contain
          :src="item.fullImagePath"
        ></v-img>
      </template>
      <template v-slot:item.clear="{ item }">
        <v-avatar color="teal" size="26" rounded>
          <router-link
            :to="{
              name: 'TitleDefinitionEdit',
              params: { titleDefinitionId: item.id }
            }"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </router-link>
        </v-avatar>
      </template>
      <template v-slot:item.add="{ item }">
        <v-avatar color="red darken-4" size="26" rounded>
          <v-icon dark @click="delRecord(item)">mdi-delete</v-icon>
        </v-avatar>
      </template>
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-avatar color="indigo" size="30">
              <v-icon
                dark
                @click="
                  page = 1;
                  retrieveTitleDefinitions();
                "
                >mdi-magnify
              </v-icon>
            </v-avatar>
          </td>
          <td>
            <v-avatar color="grey" size="30">
              <v-icon
                dark
                @click="
                  page = 1;
                  clearSearch();
                "
                >mdi-close
              </v-icon>
            </v-avatar>
          </td>
          <td>
            <router-link :to="{ name: 'TitleDefinitionCreate' }">
              <v-avatar color="teal" size="26" rounded>
                <v-icon dark>mdi-plus</v-icon>
              </v-avatar>
            </router-link>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ConfirmDialog from "@/view/pages/ConfirmDialog";

export default {
  name: "sectors",
  computed: {
    headers() {
      return [
        { text : "Id" , value : "id" , align : "start" } ,
        { text : this.$i18n.t('common.title') , value : "title" } ,
        { text : this.$i18n.t('common.image') , value : "image" } ,
        { text : "" , value : "search" , width : "5%" } ,
        { text : "" , value : "clear" , width : "5%" } ,
        { text : "" , value : "add" , width : "5%" }
      ]
    }
  },
  data() {
    return {
      totalTitleDefinitions: 0,
      titleDefinitions: [],
      loading: true,
      pagination: {},
      dialogDelete: false,
      itemToDelete: null,
      mediaList: [],
      errors: []
    };
  },
  watch: {
    pagination: {
      handler() {
        this.retrieveTitleDefinitions();
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Title Definitions" }]);
  },
  components: {
    ConfirmDialog
  },
  methods: {
    async delRecord(item) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('common.confirm'),
          this.$i18n.t('pages.titleDefinition.deleteMessage') +
            item.id +
            " ?"
        )
      ) {
        this.deleteRecord(item);
      }
    },
    deleteRecord(item) {
      this.deleteTitleDefinition(item.id);
    },
    deleteTitleDefinition(titleDefinitionId) {
      this.loading = true;
      ApiService.delete(
        `api/promotion-title-definition/${titleDefinitionId}`
      )
        .then(response => {
          this.$log.debug("Promotion-title-definition deleted: ", response);
          this.retrieveTitleDefinitions();
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getRequestParams() {
      let params = {};

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortBy[0];
        if (sortDesc[0] === true) sort += ",desc";
      }
      params["sort"] = sort;
      params["page"] = this.pagination.page;
      params["size"] = this.pagination.itemsPerPage;

      return params;
    },
    retrieveTitleDefinitions() {
      const params = this.getRequestParams();
      return new Promise(resolve => {
        this.loading = true;
        ApiService.query("api/promotion-title-definition", {
          params
        }).then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug("Title definitions: ", response.data.content);
          this.titleDefinitions = response.data.content;
          this.totalTitleDefinitions = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.loading = false;
          let title =
            this.titleDefinitions != null ? this.titleDefinitions.length : 0;
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Title Definitions: " + title }
          ]);
          resolve();
        });
      });
    }
  }
};
</script>

<style>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}
.v-icon.v-icon {
  font-size: 24px !important;
}
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
